module.exports = __webpack_public_path__ + "2d66b9b5b86cdbcc463cb91cd8489855.png";